export default {
    init() {
        const element = document.querySelectorAll('[data-fade-in]');

        element.forEach(fadeIn => {
            const delay = fadeIn.getAttribute('data-fade-in');

            gsap.from(fadeIn, {
                opacity: 0,
                duration: 0.3,
                delay: delay,
                scrollTrigger: {
                    trigger: fadeIn,
                    once: false,
                    toggleActions: 'play none play none'
                }
            });
        });
    }
};
